import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ReviewCard from "@/components/feature/ReviewCard";
import { reviews } from "@/mocks/articles";

export default function AboutPage() {
  return (
    <main>
      <Navbar />

      <section className="bg-background-100 pt-24 pb-16 md:pb-20">
        <div className="px-6 md:px-14">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-2/3">
              <span className="inline-block px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-xs font-medium mb-6">
                关于今日大瓜
              </span>
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
                让吃瓜
                <br />
                变得更有趣
              </h1>
              <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4 max-w-xl">
                <p>
                  今日大瓜成立于2024年，是一个专注于娱乐圈八卦与社会热点整合的新媒体平台。我们的使命很简单——让每一个热爱吃瓜的人，都能在第一时间获取到最新、最全、最有深度的瓜料。
                </p>
                <p>
                  在这个信息爆炸的时代，热点来得快去得也快。我们的编辑团队7x24小时不间断追踪全网动态，从海量信息中筛选出真正值得关注的"大瓜"，并为你梳理清楚事件的来龙去脉。
                </p>
                <p>
                  我们相信，吃瓜不仅仅是一种娱乐，更是一种社交方式。每天中午和同事聊聊最新的瓜，已经成为无数人日常生活的一部分。而今日大瓜，就是那个让你在朋友圈里永远走在八卦最前沿的秘密武器。
                </p>
                <p>
                  目前，今日大瓜已拥有超过300万忠实读者，日均内容阅读量突破千万。我们也在不断拓展内容边界，从最初的明星八卦，延伸到社会热点、网络爆款、深度解析等多个维度。
                </p>
                <p>
                  未来，我们将继续坚持"快、准、深"的内容理念，用更有趣的方式讲好每一个瓜。欢迎你加入我们的吃瓜大军，一起围观这个热闹的世界。
                </p>
              </div>
            </div>

            <div className="lg:w-1/3">
              <div className="flex gap-4">
                <div className="flex-[4] rounded-2xl overflow-hidden h-[320px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20modern%20creative%20office%20workspace%20with%20warm%20lighting%2C%20minimalist%20design%2C%20cream%20walls%2C%20wooden%20desk%2C%20laptop%20and%20coffee%2C%20professional%20atmosphere%2C%20clean%20aesthetic%2C%20no%20people&width=500&height=650&seq=about-team-1&orientation=portrait"
                    alt="今日大瓜编辑团队"
                    title="今日大瓜团队 - 编辑部工作场景"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-[6] rounded-2xl overflow-hidden h-[320px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20creative%20team%20collaboration%20space%20with%20mood%20board%20and%20warm%20lighting%2C%20minimalist%20design%2C%20cream%20walls%2C%20magazine%20aesthetic%2C%20professional%20creative%20atmosphere%2C%20clean%20composition&width=700&height=650&seq=about-team-2&orientation=portrait"
                    alt="今日大瓜创意空间"
                    title="今日大瓜 - 创意讨论空间"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="px-6 md:px-14">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">瓜友口碑</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              听听瓜友们
              <br className="md:hidden" />
              怎么说
            </h2>
            <p className="text-foreground-500 text-sm max-w-md mx-auto">
              300万+ 吃瓜群众的真实评价
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {reviews.map((review, idx) => (
              <ReviewCard
                key={review.id}
                name={review.name}
                avatar={review.avatar}
                role={review.role}
                rating={review.rating}
                content={review.content}
                isLast={idx >= reviews.length - 2}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-16 md:py-20">
        <div className="px-6 md:px-14">
          <div className="max-w-xl mx-auto text-center mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-foreground-500 text-sm mb-8">
              有料要爆？有瓜要分享？欢迎随时联系我们，你的爆料可能就是下一个全网热搜
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-foreground-600 mb-8">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                tips@00kkke.cn
              </span>
              <span className="hidden sm:block text-foreground-300">|</span>
              <span className="flex items-center gap-2">
                <i className="ri-weibo-line text-primary-500"></i>
                @今日大瓜官方
              </span>
              <span className="hidden sm:block text-foreground-300">|</span>
              <span className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500"></i>
                今日大瓜
              </span>
            </div>

            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d913mus6ci2plld1oi90"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                placeholder="输入你的邮箱，获取最新瓜报"
                required
                className="flex-1 px-5 py-3.5 rounded-full bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-400 border border-background-200/70 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="absolute opacity-0 pointer-events-none"
              />
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                免费订阅
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div className="w-full h-[160px] md:h-[220px] overflow-hidden rounded-3xl bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Wide%20editorial%20banner%20with%20abstract%20warm%20toned%20paper%20textures%20floating%2C%20cream%20and%20amber%20palette%2C%20minimalist%20clean%20composition%2C%20elegant%20magazine%20aesthetic%2C%20no%20text&width=1600&height=400&seq=about-cta-banner&orientation=landscape"
              alt="加入今日大瓜"
              title="加入今日大瓜吃瓜大军"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
